import {Localize} from "@dp-instant/i18n";
import {WaitAction} from "@dp-instant/core";
import {Button} from "@dp-instant/ui";
import {UIConstants} from "@game/ui/constants";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {useState} from "preact/hooks";
import "./TapToPlayButton.less";
import {hapticMedium} from "@game/haptic";

export const TapToPlayButton = (props: IClickableComponentProps & {onDown?: () => void}) => {
    const initialState = {
        text: Localize.get("ui-menu-tap_to_play", "TAP TO PLAY"),
        animationStarted: false,
        clicked: false
    };

    const {showGoDelay, hideDelay} = UIConstants.tapToPlayButton;

    const [state, setState] = useState(() => initialState);

    const onClickHandler = async () => {
        hapticMedium();
        const text = Localize.get("tap_to_play_go", "GO!");
        setState(state => ({...state, text, clicked: true}));
        props.onDown && props.onDown();
        await WaitAction.ms(showGoDelay);
        setState(state => ({...state, animationStarted: true}));
        await WaitAction.ms(hideDelay - showGoDelay);
        props.onClick && props.onClick();
    };

    return (
        <Button
            disabled={state.clicked}
            className={cn("button", "start-button", {
                "start-button_clicked": state.clicked,
                "start-button_animated": state.animationStarted
            })}
            {...props}
            onClick={onClickHandler}
        >
            {state.text}
        </Button>
    );
};
